import axios from 'axios';
import { api, resolvePagination } from './api';

/**
 * Obter todos os conteúdos.
 */
export const getLearningPosts = async (pageLimit, pageToken) => {
    const headers = resolvePagination(pageToken, pageLimit);
    return api.get('/cheart/learning/posts', { headers });
};

/**
 * Obter conteúdos por tags
 */
export const getLearningPostsByTags = async (tags, pageLimit, pageToken) => {
    const headers = resolvePagination(pageToken, pageLimit);

    return api.post('/cheart/learning/posts/filter', { tags }, { headers });
};

/**
 * Criar novo conteúdo
 * @param {string} title - Título do conteúdo
 * @param {string} description - Descrição do conteúdo
 * @param {string} format - Formato do conteúdo
 * @param {string} content - Conteúdo HTML
 * @param {string|null} featured_media - UUID da media destacada.
 * @param {Array<string>} media - Lista de UUIDs de media adicionais.
 * @param {Array<string>} tags - Lista de UUIDs de tags associadas.
 */
export const createLearningPost = async ({
    title,
    description,
    format,
    content,
    featured_media = null,
    media = [],
    tags = []
}) => {
    const payload = {
        title,
        description,
        format,
        content,
        featured_media,
        media,
        tags
    };

    const axiosInstance = api;

    const response = await axiosInstance.post('/cheart/learning/posts', payload);
    return response.data;
};

/**
 * Procurar conteúdo.
 * @param {string} uuid - UUID do conteúdo.
 *
 */
export const fetchLearningByUUID = async (uuid) => {
    const response = await api.post('/cheart/learning/posts/fetch', { uuid });
    return response.data;
};

/**
 * Obter lista de tags.
 */
export const getLearningTags = async () => {
    const response = await api.get('/cheart/learning/tags');
    return response.data;
};

/**
 * Criar uma nova tag.
 * @param {string} tag - Nome da tag.
 */
export const createLearningTag = async (tag) => {
    const response = await api.post('/cheart/learning/tags', { tag });
    return response.data;
};

/**
 * Obter lista de media.
 */
export const getLearningMedia = async () => {
    const response = await api.get('/cheart/learning/media');
    return response.data;
};

/**
 * Enviar ficheiro de media.
 * @param {File} file - Ficheiro a enviar.
 */
export const uploadLearningMedia = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/cheart/learning/media', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    return response.data;
};

/**
 * Atribuir conteúdo a pacientes.
 * @param {string} postUUID - UUID do post.
 * @param {Array<string>} patientUUIDs - Lista de UUIDs de pacientes.
 * @param {string|null} not_before - Data/hora de início.
 * @param {string|null} not_after - Data/hora de fim.
 */
export const assignLearningToPatients = async (
    postUUID,
    patientUUIDs,
    not_before = null,
    not_after = null
) => {
    const payload = {
        post: postUUID,
        patients: patientUUIDs,
        ...(not_before && { not_before }),
        ...(not_after && { not_after })
    };

    const response = await api.post('/cheart/learning/assign/patients', payload);
    return response.data;
};

/**
 * Atribuir conteúdo a um grupo.
 * @param {string} postUUID - UUID do post.
 * @param {string} groupUUID - UUID do grupo.
 * @param {string|null} not_before - Data/hora de início.
 * @param {string|null} not_after - Data/hora de fim.
 */
export const assignLearningToGroup = async (
    postUUID,
    groupUUID,
    not_before = null,
    not_after = null
) => {
    const payload = {
        post: postUUID,
        group: groupUUID,
        ...(not_before && { not_before }),
        ...(not_after && { not_after })
    };

    const response = await api.post('/cheart/learning/assign/group', payload);
    return response.data;
};

/**
 * Obter lista de pacientes com um conteudo já atribuido.
 * @param {string} postUUID - UUID do post.
 */
export const getAssignedPatientsForPost = async (postUUID) => {
    const response = await api.post('/cheart/learning/post/patients', {
        uuid: postUUID
    });
    return response.data;
};

/**
 * Editar conteudo de aprendisagem.
 */
export const updateLearningPost = async (payload) => {
    const response = await api.patch('/cheart/learning/posts', payload);
    return response.data;
};
